'use client';

import {
  HomeLandingSections,
  HomeStoriesSection,
  HomeCommunitySection,
  HomeVoicesSection,
  HomeAboutSection,
  CommunityMatrimonyServices,
} from '@/components/homePageSections';

import { useState } from 'react';
import Header from '@/components/Header';
import HomeHeroSection from '@/components/HomeHeroSection';

const communityServices: { label: string; href?: string }[] = [
  { label: "Kunbi Vadhu Var Suchak Mandal Thane" },
  { label: "Kunbi Vadhu Var Suchak Mandal Kalyan" },
  { label: "Kunbi Vadhu Var Suchak Mandal" },
  { label: "Kunbi Vadhu Var Suchak Mandal Dapoli" },
  { label: "Kunbi Vadhu Var Suchak Mandal Pune" },
  { label: "Kunbi Vadhu Var Suchak Mandal WhatsApp group link" },
  { label: "Kunbi Vadhu Var Suchak Mandal Mumbai" },
  { label: "Kunbi Vadhu Var Suchak Mandal Chiplun" },
  { label: "Kunbi Vadhu Var Melava Thane" },
  { label: "Tirale Kunbi Vadhu" },
  { label: "Tirale Kunbi Grooms" },
  { label: "Kunbi Vadhu Var Suchak Mandal Ratnagiri" },
  { label: "Kunbi Vadhu Var Suchak" },
  { label: "Kunbi matrimony Thane" },
  { label: "Thane Kunbi matrimony" },
  { label: "Kunbi matrimony WhatsApp group" },
  { label: "Tirale Kunbi matrimony Nagpur" },
  { label: "Tilori Kunbi matrimony" },
  { label: "Kunbi matrimony Nagpur" },
  { label: "Bawne Kunbi matrimony" },
  { label: "Kunbi Matrimony Login" },
  { label: "Bawane Kunbi matrimony" },
  { label: "Khedule Kunbi matrimony" },
  { label: "Kunbi Matrimony grooms" },
  { label: "Khaire Kunbi matrimony" },
  { label: "Maratha Kunbi matrimony" },
  { label: "Kunbi Matrimony - Nagpur" },
  { label: "Hindu Kunbi matrimony" },
  { label: "Tirale Kunbi Matrimony Amravati" },
  { label: "Dhanoje Kunbi Matrimony" },
  { label: "Kunbi Matrimony Profiles" },
  { label: "Kunbi Caste" },
  { label: "Kunbi Maratha records" },
  { label: "Kunbi Caste category" },
  { label: "Kunbi Maratha" },
  { label: "Pune Jilha Kunbi Nondi" },
  { label: "Kunbi Caste Certificate" },
  { label: "Kunbi Caste in Marathi" },
  { label: "Beed Kunbi Nondi in Marathi" },
  { label: "Kunbi Maratha Surname list" },
  { label: "Kunbi Nondi Beed" },
  { label: "Kunbi Maratha list pdf" },
  { label: "Pune Kunbi Nondi in Marathi" },
  { label: "Kunbi Nondi Ahmednagar" },
  { label: "Kunbi Maratha caste" },
  { label: "Kunbi Maratha records Satara" },
  { label: "Kunbi Maratha list" },
  { label: "Kunbi Maratha records Sangli district" },
  { label: "Kunbi Maratha records Ahmednagar" },
  { label: "Kunbi Maratha records Sangli district pdf" },
  { label: "Hyderabad gazette Kunbi Maratha pdf" },
  { label: "Kunbi Maratha records Beed district" },
  { label: "Kunbi Maratha records Nashik" },
  { label: "Kunbi Maratha documents" },
  { label: "Kunbi Maratha records Pune" },
  { label: "Kunbi Maratha caste certificate" },
  { label: "Kunbi Maratha records pdf download" },
  { label: "Kunbi Maratha records Satara pdf" },
  { label: "Dharashiv Kunbi Maratha list" },
  { label: "Kunbi Maratha records Kolhapur district" },
  { label: "कुणबी समाज विवाह मंडळ" },
];

export default function KunbiMatrimony() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  return (
    <div className="bg-white">
      {/* Transparent Header */}
      <Header variant="transparent" />

      <HomeHeroSection
        title="मराठा कुणबी वधू वरांसाठी"
        subtitle="महाराष्ट्रातील अग्रणी विवाहसंस्था"
        trackingSource="kunbi_matrimony"
      />

      <HomeLandingSections />

      <HomeStoriesSection />

      <HomeCommunitySection />

      <HomeVoicesSection />

      <HomeAboutSection />

      {/* FAQ Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
            Frequently Asked Questions
          </h2>
          <div className="max-w-4xl mx-auto">
            <div className="space-y-4">
              {[
                {
                  question: "Which is the best Kunbi Vadhu Var Suchak Mandal Mumbai?",
                  answer: "In Maharashtra state, MarathiVadhuVarSuchak.com Marathi matrimony is the most trusted Kunbi Vadhu Var Suchak Mandal in Mumbai."
                },
                {
                  question: "How to search the Kunbi Vadhu Var Cast category?",
                  answer: "To search the Kunbi Vadhu Var Caste category wise first register free through MarathiVadhuVarSuchak.com Marathi matrimonial site."
                },
                {
                  question: "How to search the Kunbi Vadhu Var age wise?",
                  answer: "MarathiVadhuVarSuchak.com Marathi matrimony has advance features to search Kunbi Vadhu Var profiles including age."
                },
                {
                  question: "Which is the best Kunbi Vadhu Var Suchak Mandal Thane?",
                  answer: "For Kunbi Vadhu Var from Thane region could register free through MarathiVadhuVarSuchak.com Marathi matrimony or mobile app."
                },
                {
                  question: "Which is the trusted Kunbi Vadhu Var Suchak Mandal Kalyan?",
                  answer: "MarathiVadhuVarSuchak.com Marathi matrimony is the most trusted Kunbi Vadhu Var Suchak Mandal in Maharashtra."
                },
                {
                  question: "How to register at Thane Kunbi Vadhu Var Suchak Kendra?",
                  answer: "Visit MarathiVadhuVarSuchak.com Marathi matrimonial site to register free. Here you will find many profiles belong to Kunbi Samaj bride and grooms."
                },
                {
                  question: "Which is the best Marathi Matrimony Tirale Kunbi Vadhu Var Suchak Mandal?",
                  answer: "MarathiVadhuVarSuchak.com is the best Marathi Matrimony Tirale Kunbi Vadhu Var Suchak Mandal in Maharashtra."
                },
                {
                  question: "How to do Kunbi Matrimony login process?",
                  answer: "First you have to signup free through MarathiVadhuVarSuchak.com matrimony. Then you can login to search Kunbi Vadhu Var profiles."
                },
                {
                  question: "How to join Kunbi matrimony WhatsApp group link?",
                  answer: "No! As per privacy policy of MarathiVadhuVarSuchak.com matrimony, we do not have any Whatsapp group link to join."
                },
                {
                  question: "How to join Kunbi matrimony WhatsApp Number?",
                  answer: "MarathiVadhuVarSuchak.com matrimony privacy policy do not allowed providing profile data on WhatsApp group."
                },
                {
                  question: "Which is the best Kunbi matrimony Mumbai?",
                  answer: "MarathiVadhuVarSuchak.com Marathi matrimony is the best Kunbi matrimony in Mumbai city."
                },
                {
                  question: "Which is the trusted Kunbi matrimony Thane?",
                  answer: "MarathiVadhuVarSuchak.com Marathi matrimony is the most trusted Kunbi matrimony in Thane city."
                },
                {
                  question: "What is the Kunbi matrimony contact number?",
                  answer: "Visit MarathiVadhuVarSuchak.com Marathi matrimony and check contact us page for official contact number."
                },
                {
                  question: "Which is the trusted Marathi Kunbi matrimony Mumbai?",
                  answer: "MarathiVadhuVarSuchak.com Marathi matrimony is the most trusted Kunbi matrimony in Mumbai."
                },
                {
                  question: "How to search Kunbi Samaj Mumbai office?",
                  answer: "Marathi Vadhu Var Suchak office is located in Mumbai Andheri East. Visit official site for more details."
                },
                {
                  question: "How to join Kunbi Maratha Vadhu Var group?",
                  answer: "No WhatsApp group exists for MarathiVadhuVarSuchak.com Marathi matrimony due to privacy policy."
                }
              ].map((faq, index) => (
                <div key={index} className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
                  <button
                    onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
                    className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
                  >
                    <h3 className="text-lg font-semibold text-gray-900">
                      {faq.question}
                    </h3>
                    <svg
                      className={`w-5 h-5 text-gray-500 transition-transform duration-300 ${
                        openFAQ === index ? 'rotate-180' : ''
                      }`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  <div
                    className={`px-6 transition-all duration-300 ease-in-out ${
                      openFAQ === index ? 'pb-4 max-h-96 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'
                    }`}
                  >
                    <div className="text-gray-600 leading-relaxed py-3">
                      <p className="mb-3">{faq.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <CommunityMatrimonyServices
        title="Kunbi Matrimony for Maratha Kunbi Communities"
        items={communityServices}
      />

    </div>
  );
}
